<template>
  <div>
    <Card>
      <div class="filter-container">
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="会员姓名"
          v-model="searchData['q[fresh_customer_username_matches]']"
        />
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          placeholder="会员号码"
          v-model="searchData['q[fresh_customer_mobile_matches]']"
        />
         <el-select
          clearable
          style="width: 200px"
          class="filter-item"
          v-model="searchData['q[shop_id_eq]']"
          placeholder="所选店铺"
        >
          <el-option :label="item.name" :value="item.id" v-for="item in shops" :key="item.id"/>
        </el-select>
        <el-select
          clearable
          style="width: 200px"
          class="filter-item"
          v-model="searchData['q[status_eq]']"
          placeholder="订单状态"
        >
          <el-option v-for="item in orderStatus" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
        <el-select
          clearable
          style="width: 200px"
          class="filter-item"
          v-model="searchData['q[payment_method_eq]']"
          placeholder="收款方式"
        >
          <el-option v-for="item in paymentMethods" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
        <el-date-picker
          type="date"
          placeholder="创建时间起"
          v-model="searchData['q[created_at_gt]']"
          style="width: 200px;"
          class="filter-item"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          type="date"
          placeholder="创建时间止"
          v-model="searchData['q[created_at_lt]']"
          style="width: 200px;"
          class="filter-item"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-button
          size="medium"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="searchBtnClick()"
          >搜索</el-button
        >
        <el-button
          size="medium"
          class="filter-item"
          type="primary"
          @click="resetBtnClick()"
          >重置</el-button
        >
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   :loading="exportLoading"
                   icon="el-icon-download"
                   @click="exportData">导出</el-button>
        <!-- <el-button
          size="medium"
          class="filter-item"
          style="margin-left: 10px;"
          @click="handleDownload"
          type="danger"
          icon="el-icon-download"
          :loading="downloadLoading"
        >导出Excel</el-button>
        <el-button
          size="medium"
          class="filter-item"
          style="margin-left: 10px;"
          v-checkBuyedPlugin="[9]"
          @click="openDown2"
          type="danger"
          icon="el-icon-download"
        >导出销售明细</el-button>-->
      </div>
      <el-alert
        v-if="aggregate_test"
        :title="aggregate_test"
        type="success"
        :closable="false"
      ></el-alert>
      <Table
        style="margin-top: 20px;"
        border
        :loading="loading"
        :columns="columns"
        :data="orders"
        :changePage="changePage"
        @on-row-click="onRowClick"
      >
        <template slot="address" slot-scope="{row}">
          <div>
            {{ row.fresh_address_province }} {{ row.fresh_address_city }} {{ row.fresh_address_district }}
            {{ row.fresh_address_content }}
          </div>
        </template>
        <template slot="action" slot-scope="{row}">
          <div>
            <i-button type="primary" @click="onRowClick(row)">查看</i-button>
          </div>
        </template>
      </Table>
      <Row>
        <Page
          style="margin-top: 20px;"
          show-total
          :total="meta.total"
          :current="meta.current"
          :page-size="meta.pageSize"
          @on-change="changePage"
        ></Page>
      </Row>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { booleanChinese, podStatus, paymentChinese } from '@/libs/table-render'
import { paymentMethods, orderStatus } from '@/libs/value-list.js'
import axios from 'axios'
const exportFields = [
  {
    title: '商品名',
    key: 'current_product_name'
  },
  {
    title: '单价',
    key: 'current_price'
  },
  {
    title: '销售数量',
    key: 'quantity'
  },
  {
    title: '销售金额',
    key: 'total'
  }
  // {
  //   title: '销售占比',
  //   key: 'percentage',
  // },
]

export default {
  data () {
    return {
      exportFields,
      paymentMethods,
      orderStatus,
      searchData: {
        id: undefined
      },
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: '店铺名称',
          key: 'shop_name',
          width: 160,
          align: 'center'
        },
        {
          width: 180,
          title: '订单号',
          key: 'code',
          align: 'center'
        },
        {
          title: '下单平台',
          key: 'come_from',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h(
              'div',
              params.row.come_from === 'wechat_mini' ? '小程序' : '前台'
            )
          }
        },
        {
          title: '创建时间',
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: '支付状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: '付款方式',
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: '会员名称',
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: '会员手机',
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        },
        {
          title: '桌台信息',
          key: 'fresh_desk_name',
          width: 180,
          align: 'center'
        },
        {
          title: '客单价',
          key: 'average_price',
          width: 100,
          align: 'center'
        },
        {
          title: '商品总价',
          key: 'total',
          width: 100,
          align: 'center'
        },
        {
          title: '支付折扣',
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.discount + '%')
          }
        },
        {
          title: '是否抹零',
          key: 'small_discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.small_discount)
          }
        },
        {
          title: '折后价',
          key: 'discounted_total',
          width: 100,
          align: 'center'
        },
        {
          title: '实际支付',
          key: 'finish_total',
          width: 100,
          align: 'center'
        },
        {
          title: '用户支付',
          key: 'payment_total',
          width: 100,
          align: 'center'
        },
        {
          title: '找零',
          key: 'change_amount',
          width: 100,
          align: 'center'
        },
        {
          title: '收货地址',
          slot: 'address',
          width: 300
        }
      ],
      exportLoading: false,
      ordersAll: []
    }
  },
  created () {
    this.resetQuery()
    this.shopIndex({ per: 1000 })
    this.index()
  },
  computed: {
    ...mapGetters('order', ['orders', 'meta', 'loading', 'aggregate_test']),
    ...mapGetters('shop', ['shops'])
  },
  methods: {
    ...mapActions('order', ['index']),
    ...mapActions('shop', {
      shopIndex: 'index'
    }),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    mergeOrderItems (list1 = [], list2 = []) {
      const result1 = []
      const result2 = []
      console.log(list1, list2, '=====>')
      list1.forEach(item1 => {
        const findItem = list2.find(item2 => item2.fresh_product_id === item1.fresh_product_id)
        console.log('findItem', findItem)
        if (findItem) {
          result1.push({
            ...item1,
            quantity: findItem.quantity + item1.quantity,
            total: findItem.total + item1.total
          })
        } else {
          result1.push({
            ...item1
          })
        }
      })
      list2.forEach(item2 => {
        const findItem = list1.find(item1 => item1.fresh_product_id === item2.fresh_product_id)
        if (!findItem) {
          result2.push({
            ...item2
          })
        }
      })
      return [...result1, ...result2]
    },
    async exportData () {
      this.exportLoading = true
      axios.get('orders', { params: { ...this.searchData, ...{ per: 65535, page: 1 } } }).then(({ data: list }) => {
        this.exportLoading = false
        const map = {}
        list.forEach((item) => {
          if (map[item.shop_name]) {
            map[item.shop_name].fresh_order_items = this.mergeOrderItems(map[item.shop_name].fresh_order_items, item.fresh_order_items)
          } else {
            map[item.shop_name] = {
              id: item.id,
              fresh_order_items: item.fresh_order_items || []
            }
          }
        })
        console.log('map', map)
        this.ordersAll = Object.keys(map).map(key => {
          return { firstRow: { rowspan: map[key].fresh_order_items.length, name: key, data: map[key].fresh_order_items[0] || {} }, otherRows: map[key].fresh_order_items.slice(1), id: map[key].id }
        })
        console.log('this.ordersAll', this.ordersAll)
        setTimeout(() => {
          const book = XLSX.utils.book_new()
          const s1 = XLSX.utils.table_to_sheet(this.$refs.exportTable)
          XLSX.utils.book_append_sheet(book, s1, '商品销售表')
          const base64 = XLSX.write(book, { bookType: 'xlsx', type: 'base64' })
          const a = document.createElement('a')
          a.setAttribute('download', '商品销售表.xlsx')
          a.href = 'data:application/vnd.ms-excel;base64,' + base64
          a.click()
        }, 20)
      })
    },

    changePage (page) {
      this.changeQuery({ page })
      this.index()
    },
    onRowClick (params) {
      this.$router.push(`/orders/${params.id}`)
    },
    handleVague (queryData) {
      // 模糊查询加%
      Object.keys(queryData).forEach((item) => {
        if (['q[shop_name_matches]', 'q[chain_store_name]', 'q[fresh_customer_mobile_matches]', 'q[fresh_customer_username_matches]'].indexOf(item) > -1) {
          queryData[item] = `%${queryData[item]}%`
        }
      })
      return queryData
    },
    resetBtnClick () {
      this.resetQuery()
      this.searchData = {}
    },
    searchBtnClick () {
      this.resetQuery()
      const queryData = this.handleVague({ ...this.searchData })
      this.changeQuery(queryData)
      this.index()
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/filter-container.less";
</style>
